"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Screen;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = (fullScreenContent) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { sixPercentOfScreen } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        scrollLandscape: {
            backgroundColor: THEME.SoftGray,
            overflow: "scroll"
        },
        scrollPortrait: {
            backgroundColor: THEME.ScreenBackground,
            overflow: "scroll"
        },
        containerLandscape: {
            backgroundColor: THEME.SoftGray,
            paddingBottom: fullScreenContent ? 0 : 12,
            paddingHorizontal: fullScreenContent ? 0 : sixPercentOfScreen,
            paddingTop: fullScreenContent ? 0 : 8
        },
        containerPortrait: {
            backgroundColor: THEME.ScreenBackground,
            paddingBottom: 4,
            paddingHorizontal: 0,
            paddingTop: 0
        }
    });
};
const Scrollable = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    if (props.scrollEnabled) {
        let refreshControl;
        if (!Helper_1.Helper.isPlatformWeb && props.onRefresh) {
            refreshControl = ((0, jsx_runtime_1.jsx)(react_native_1.RefreshControl, { colors: [THEME.Secondary], refreshing: props.refreshing, onRefresh: props.onRefresh }));
        }
        return ((0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { style: props.style, contentContainerStyle: props.containerStyle, refreshControl: refreshControl, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { children: props.children }) }));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [props.style, { flex: 1 }, props.containerStyle], children: props.children }));
    }
};
function Screen(props) {
    const styles = useStyles(props.fullScreenContent ?? false);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsx)(Scrollable, { containerStyle: [
            size != 'sm' ? styles.containerLandscape : styles.containerPortrait,
            (props.cardAdjust ?? true) ? { marginVertical: -4 } : null,
            props.containerStyle
        ], onRefresh: props.onRefresh, refreshing: props.refreshing ?? false, scrollEnabled: props.scrollEnabled ?? true, style: [
            size != 'sm' ? styles.scrollLandscape : styles.scrollPortrait,
            (props.cardAdjust ?? true) ? { marginBottom: -4 } : null,
            !(props.scrollEnabled ?? true) ? props.noScrollStyle : props.scrollStyle
        ], children: props.children }));
}
